<template>
  <div class="col-md-12 col-sm-12 col-xs-12">
    <h5>THÔNG TIN SỐ</h5>
    <div class="col-md-12 col-sm-12 col-xs-12 h-100">
      <div class="form-group col-md-4 col-sm-6 col-xs-12">
        <label>SĐT</label>
        <input type="text" class="form-control" v-model="phoneNumberDetail.phone_number" disabled/>
      </div>
      <div class="form-group col-md-4 col-sm-6 col-xs-12">
        <label>Số chủ</label>
        <input type="text" class="form-control" v-model="phoneNumberDetail.main_phone_number_text" disabled/>
      </div>
      <div class="form-group col-md-4 col-sm-6 col-xs-12">
        <label>Pháp nhân</label>
        <input type="text" class="form-control" v-model="phoneNumberDetail.legal_text" disabled/>
      </div>
      <div class="form-group col-md-4 col-sm-6 col-xs-12">
        <label>Ngày Lấy</label>
        <input type="text" class="form-control" v-model="phoneNumberDetail.pickup_date" disabled/>
      </div>
      <div class="form-group col-md-4 col-sm-6 col-xs-12">
        <label>Khách hàng sử dụng</label>
        <input type="text" class="form-control" v-model="phoneNumberDetail.phone_number_client_text" disabled/>
      </div>
      <div class="form-group col-md-4 col-sm-6 col-xs-12">
        <label>Brand</label>
        <input type="text" class="form-control" v-model="phoneNumberDetail.brand" disabled/>
      </div>
      <div class="form-group col-md-4 col-sm-6 col-xs-12">
        <label>Nhà cung cấp</label>
        <input type="text" class="form-control" v-model="phoneNumberDetail.provider_text" disabled/>
      </div>
      <div class="form-group col-md-4 col-sm-6 col-xs-12">
        <label>Trạng thái số</label>
        <multiselect v-model="phoneNumberDetail.phone_number_status_text" :options="phone_status_list" :multiple="false"
                     :close-on-select="true"
                     placeholder="Vui lòng chọn" label="text" track-by="value" disabled></multiselect>
      </div>
      <div v-if="phoneNumber.phone_number_status === statusPhoneNumberId.MONITORING" class="form-group col-md-4 col-sm-6 col-xs-12">
        <label>Mạng bị khoá</label>
        <div>
          <div class="d-flex align-items-center mb-1">
            <b-form-checkbox style="width: 150px" id="checkbox-viettel" @change="onLockViettelChange" v-model="lockProvider.Viettel" name="Viettel">Viettel
            </b-form-checkbox>
            <date-picker placeholder="Nhập ngày khóa" v-model="viettelLockDate" valueType="format" :disabled="!lockProvider.Viettel" v-bind:clearable="false" v-bind:class="errorViettelLock ? 'has-error' : ''"></date-picker>
          </div>
          <div class="d-flex align-items-center mb-1">
            <b-form-checkbox style="width: 150px" id="checkbox-mobifone" @change="onLockMobiChange" v-model="lockProvider.Mobifone" name="Mobifone">Mobifone
            </b-form-checkbox>
            <date-picker placeholder="Nhập ngày khóa" v-model="mobifoneLockDate" valueType="format" :disabled="!lockProvider.Mobifone" v-bind:clearable="false"></date-picker>
          </div>
          <div class="d-flex align-items-center mb-1">
            <b-form-checkbox style="width: 150px" id="checkbox-vinaphone" @change="onLockVinaChange" v-model="lockProvider.Vinaphone" name="Vinaphone">Vinaphone
            </b-form-checkbox>
            <date-picker placeholder="Nhập ngày khóa" v-model="vinaphoneLockDate" valueType="format" :disabled="!lockProvider.Vinaphone" v-bind:clearable="false"></date-picker>
          </div>
          <div class="d-flex align-items-center">
            <b-form-checkbox style="width: 150px" id="checkbox-other" @change="onLockOtherChange" v-model="lockProvider.Other" name="Other">Ngoại mạng</b-form-checkbox>
            <date-picker placeholder="Nhập ngày khóa" v-model="otherLockDate" valueType="format" :disabled="!lockProvider.Other" v-bind:clearable="false"></date-picker>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12 col-sm-12 col-xs-12 h-100">
      <div v-if="phoneNumber.phone_number_status === statusPhoneNumberId.RETEST" class="form-group col-md-4 col-sm-6 col-xs-12">
        <label>Mạng mở</label>
        <div>
          <div class="d-flex align-items-center mb-1">
            <b-form-checkbox style="width: 150px" id="checkbox-viettel" @change="onUnLockViettelChange" v-model="unlockProvider.Viettel" name="Viettel">Viettel
            </b-form-checkbox>
            <date-picker placeholder="Nhập ngày mở" v-model="viettelUnLockDate" valueType="format" :disabled="!unlockProvider.Viettel" v-bind:clearable="false"></date-picker>
          </div>
          <div class="d-flex align-items-center mb-1">
            <b-form-checkbox style="width: 150px" id="checkbox-mobifone" @change="onUnLockMobiChange" v-model="unlockProvider.Mobifone" name="Mobifone">Mobifone
            </b-form-checkbox>
            <date-picker placeholder="Nhập ngày mở" v-model="mobifoneUnLockDate" valueType="format" :disabled="!unlockProvider.Mobifone" v-bind:clearable="false"></date-picker>
          </div>
          <div class="d-flex align-items-center mb-1">
            <b-form-checkbox style="width: 150px" id="checkbox-vinaphone" @change="onUnLockVinaChange" v-model="unlockProvider.Vinaphone" name="Vinaphone">Vinaphone
            </b-form-checkbox>
            <date-picker placeholder="Nhập ngày mở" v-model="vinaphoneUnLockDate" valueType="format" :disabled="!unlockProvider.Vinaphone" v-bind:clearable="false"></date-picker>
          </div>
          <div class="d-flex align-items-center">
            <b-form-checkbox style="width: 150px" id="checkbox-other" @change="onUnLockOtherChange" v-model="unlockProvider.Other" name="Other">Ngoại mạng</b-form-checkbox>
            <date-picker placeholder="Nhập ngày mở" v-model="otherUnLockDate" valueType="format" :disabled="!unlockProvider.Other" v-bind:clearable="false"></date-picker>
          </div>
        </div>
      </div>
      <div class="col-md-12 col-sm-12 col-xs-12 mb-5 mt-5">
        <div class="pull-left">
          <b-button
            v-if="phoneNumber.phone_number_status === statusPhoneNumberId.MONITORING"
            variant="danger" @click="confirmLock" :disabled="!isEditable || saving || loading">
            <span class="fa fa-floppy-o" aria-hidden="true"></span> Xác nhận khóa
          </b-button>
          <b-button
            v-if="phoneNumber.phone_number_status === statusPhoneNumberId.MONITORING"
            variant="warning" @click="warningAlert" :disabled="!isEditable || saving || loading">
            <span class="fa fa-floppy-o" aria-hidden="true"></span> Cảnh báo sai
          </b-button>
          <b-button
            v-if="phoneNumber.phone_number_status === statusPhoneNumberId.RETEST"
            variant="danger" @click="confirmLock" :disabled="!isEditable || saving || loading">
            <span class="fa fa-floppy-o" aria-hidden="true"></span> Chưa được mở
          </b-button>
          <b-button
            v-if="phoneNumber.phone_number_status === statusPhoneNumberId.RETEST"
            variant="warning" @click="confirmUnlocked" :disabled="!isEditable || saving || loading">
            <span class="fa fa-floppy-o" aria-hidden="true"></span> Đã mở
          </b-button>
          <b-button
            v-if="phoneNumber.phone_number_status === statusPhoneNumberId.WAIT_CANCEL"
            variant="danger" @click="confirmCancel" :disabled="!isEditable || saving || loading">
            <span class="fa fa-floppy-o" aria-hidden="true"></span> Xác nhận hủy
          </b-button>
          <b-button
            v-if="phoneNumber.phone_number_status === statusPhoneNumberId.NOT_USE"
            variant="warning" @click="confirmNotUse" :disabled="!isEditable || saving || loading">
            <span class="fa fa-floppy-o" aria-hidden="true"></span> Xác nhận không sử dụng
          </b-button>

          <b-button
            v-if="phoneNumber.phone_number_status === statusPhoneNumberId.NEW"
            variant="danger" @click="confirmQualified(false)" :disabled="!isEditable || saving || loading">
            <span class="fa fa-floppy-o" aria-hidden="true"></span> Số không đạt
          </b-button>
          <b-button
            v-if="phoneNumber.phone_number_status === statusPhoneNumberId.NEW"
            variant="success" @click="confirmQualified(true)" :disabled="!isEditable || saving || loading">
            <span class="fa fa-floppy-o" aria-hidden="true"></span> Số đạt
          </b-button>

          <b-button
            v-if="phoneNumber.phone_number_status === statusPhoneNumberId.FALSE_POSITIVE || phoneNumber.phone_number_status === statusPhoneNumberId.LOCKED || phoneNumber.phone_number_status === statusPhoneNumberId.UNLOCKED"
            variant="warning" @click="backToChecking" :disabled="!isEditable || saving || loading">
            <span class="fa fa-floppy-o" aria-hidden="true"></span> Chuyển về hàng chờ kiểm tra
          </b-button>

          <b-button
            v-if="phoneNumber.phone_number_status === statusPhoneNumberId.QUALIFIED || phoneNumber.phone_number_status === statusPhoneNumberId.UNQUALIFIED"
            variant="warning" @click="backToNew" :disabled="!isEditable || saving || loading">
            <span class="fa fa-floppy-o" aria-hidden="true"></span> Chuyển về hàng chờ kiểm tra
          </b-button>
          <b-button variant="secondary" @click="back"><span class="glyphicon glyphicon-remove"
                                                            aria-hidden="true"></span> Đóng
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import Multiselect from '../../../lib/vue-multiple-select/Multiselect.vue'
import {LOCAL_STORAGE_KEY, PERMISSION_KEY, PHONE_STATUS, PROVIDERS} from '../../../common/constant'
import {mapGetters} from 'vuex'
import Utils from '../../../common/utils'
import PhoneNumberAPI from '../../../api/phoneNumberApi'
import moment from 'moment/moment'

export default {
  name: 'PhoneNumberChecking',
  components: {
    DatePicker,
    Multiselect,
  },
  props: {
    phoneNumber: {
      type: Object,
      required: false
    },
    hideModal: {
      type: Function
    },
    statusPhoneNumberId: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      company: null,
      isEditable: false,
      viettelLockDate: null,
      mobifoneLockDate: null,
      vinaphoneLockDate: null,
      otherLockDate: null,
      viettelUnLockDate: null,
      mobifoneUnLockDate: null,
      vinaphoneUnLockDate: null,
      otherUnLockDate: null,
      phoneNumberDetail: {
        viettel_lock_date: null,
        mobifone_lock_date: null,
        vinaphone_lock_date: null,
        other_lock_date: null,
        viettel_unlocking_status: null,
        mobifone_unlocking_status: null,
        vinaphone_unlocking_status: null,
        other_unlocking_status: null,
        pickup_date: null
      },
      phone_status_list: PHONE_STATUS,
      provider_list: PROVIDERS,
      monthlyFees: [
        {
          created_date: new Date(),
          on_net_fee: 10000,
          off_net_fee: 20000,
          billing_month: '02/2024'
        }
      ],
      locked_confirm: false,
      false_warning: false,
      saving: false,
      loading: false,
      providerList: [],
      phoneStatusList: [],
      phoneClientList: [],
      mainPhoneNumberList: [],
      legalList: [],
      usingStatusProviders: [
        {key: 'viettel', status: ''},
        {key: 'mobifone', status: ''},
        {key: 'vinaphone', status: ''},
        {key: 'other', status: ''}
      ],
      lockingStatusProviders: [
        {key: 'viettel', status: ''},
        {key: 'mobifone', status: ''},
        {key: 'vinaphone', status: ''},
        {key: 'other', status: ''}
      ],
      lockProvider: {
        Viettel: false,
        Mobifone: false,
        Vinaphone: false,
        Other: false,
        viettelEnterDate: null,
        mobifoneEnterDate: null,
        vinaphoneEnterDate: null,
        otherEnterDate: null
      },
      unlockProvider: {
        Viettel: false,
        Mobifone: false,
        Vinaphone: false,
        Other: false,
        viettelEnterDate: null,
        mobifoneEnterDate: null,
        vinaphoneEnterDate: null,
        otherEnterDate: null
      }
    }
  },
  computed: {
    ...mapGetters([
      'userInfo',
      'editPermission'
    ]),
    errorViettelLock () {
      if (this.lockProvider.Viettel) {
        if (this.viettelLockDate === null) {
          return true
        }
        if (moment(this.viettelLockDate) < moment(this.phoneNumberDetail.pickup_date)) {
          return true
        }
      }
      return false
    },
  },
  mounted () {
    this.company = Utils.getCompanyByUserInfo(this.userInfo)
    this.initFilter()
    this.getPhoneNumberDetail()
    this.isEditable = this.hasEditPermission()
  },
  methods: {
    hasEditPermission () {
      return Utils.isAdminUser(this.userInfo) || this.editPermission.includes(PERMISSION_KEY.PHONE_NUMBER_TECHNICAL) || this.editPermission.includes(PERMISSION_KEY.PHONE_NUMBER_TECHNICAL)
    },
    async getPhoneNumberDetail () {
      if (this.phoneNumber) {
        this.buildDtoFromResponse(this.phoneNumber)
      }
    },
    onLockViettelChange () {
      this.viettelLockDate = this.lockProvider.Viettel ? moment().format('yyyy-MM-DD') : null
    },
    onLockMobiChange () {
      this.mobifoneLockDate = this.lockProvider.Mobifone ? moment().format('yyyy-MM-DD') : null
    },
    onLockVinaChange () {
      this.vinaphoneLockDate = this.lockProvider.Vinaphone ? moment().format('yyyy-MM-DD') : null
    },
    onLockOtherChange () {
      this.otherLockDate = this.lockProvider.Other ? moment().format('yyyy-MM-DD') : null
    },
    onUnLockViettelChange () {
      this.viettelUnLockDate = this.unlockProvider.Viettel ? moment().format('yyyy-MM-DD') : null
    },
    onUnLockMobiChange () {
      this.mobifoneUnLockDate = this.unlockProvider.Mobifone ? moment().format('yyyy-MM-DD') : null
    },
    onUnLockVinaChange () {
      this.vinaphoneUnLockDate = this.unlockProvider.Vinaphone ? moment().format('yyyy-MM-DD') : null
    },
    onUnLockOtherChange () {
      this.otherUnLockDate = this.unlockProvider.Other ? moment().format('yyyy-MM-DD') : null
    },
    buildDtoFromResponse (phoneNumber) {
      this.phoneNumberDetail = phoneNumber
      this.id = phoneNumber.id
      const main = this.mainPhoneNumberList.find(item => item.value === phoneNumber.main_phone_number)
      if (main) {
        this.phoneNumberDetail.main_phone_number_text = main.text
      }
      const provider = this.providerList.find(item => item.value === phoneNumber.provider)
      if (provider) {
        this.phoneNumberDetail.provider_text = provider.text
      }
      const legal = this.legalList.find(item => item.value === phoneNumber.legal)
      if (legal) {
        this.phoneNumberDetail.legal_text = legal.text
      }
      const client = this.phoneClientList.find(item => item.value === phoneNumber.phone_number_client)
      if (client) {
        this.phoneNumberDetail.phone_number_client_text = client.text
      }
      const status = this.phoneNumberDetail.phone_number_status_id = this.phoneStatusList.find(item => item.value === phoneNumber.phone_number_status)
      if (status) {
        this.phoneNumberDetail.phone_number_status_text = {text: status.text, value: status.value}
      }
      if (this.phoneNumberDetail.lock_provider.length > 0) {
        this.lockProvider = {...this.lockProvider, ...JSON.parse(this.phoneNumberDetail.lock_provider)}
      }
      this.usingStatusProviders = [
        {
          key: 'viettel',
          status: this.phoneNumberDetail.viettel_using_status
        },
        {
          key: 'mobifone',
          status: this.phoneNumberDetail.mobifone_using_status
        },
        {
          key: 'vinaphone',
          status: this.phoneNumberDetail.vinaphone_using_status
        },
        {
          key: 'other',
          status: this.phoneNumberDetail.other_using_status
        }
      ]

      this.lockingStatusProviders = [
        {
          key: 'viettel',
          status: this.phoneNumberDetail.viettel_unlocking_status
        },
        {
          key: 'mobifone',
          status: this.phoneNumberDetail.mobifone_unlocking_status
        },
        {
          key: 'vinaphone',
          status: this.phoneNumberDetail.vinaphone_unlocking_status
        },
        {
          key: 'other',
          status: this.phoneNumberDetail.other_unlocking_status
        }
      ]

      if (phoneNumber.phone_number_status === this.statusPhoneNumberId.MONITORING) {
        if (this.phoneNumberDetail.lock_history_id && this.phoneNumberDetail.lock_histories.length > 0) {
          let lock_history = this.phoneNumberDetail.lock_histories.find(item => item.id === this.phoneNumberDetail.viettel_lock_history_id)
          if (lock_history && lock_history.unlock_lock_date === null) {
            this.lockProvider.Viettel = true
            this.viettelLockDate = lock_history.viettel_lock_date
          }

          lock_history = this.phoneNumberDetail.lock_histories.find(item => item.id === this.phoneNumberDetail.mobifone_lock_history_id)
          if (lock_history && lock_history.unlock_lock_date === null) {
            this.lockProvider.Mobifone = true
            this.mobifoneLockDate = lock_history.mobifone_lock_date
          }

          lock_history = this.phoneNumberDetail.lock_histories.find(item => item.id === this.phoneNumberDetail.vinaphone_lock_history_id)
          if (lock_history && lock_history.unlock_lock_date === null) {
            this.lockProvider.Vinaphone = true
            this.vinaphoneLockDate = lock_history.vinaphone_lock_date
          }

          lock_history = this.phoneNumberDetail.lock_histories.find(item => item.id === this.phoneNumberDetail.other_lock_history_id)
          if (lock_history && lock_history.unlock_lock_date === null) {
            this.lockProvider.Other = true
            this.otherLockDate = lock_history.other_lock_date
          }
        }

        if (this.lockProvider.Viettel && this.viettelLockDate === null) {
          this.viettelLockDate = this.lockProvider.viettelEnterDate
        }
        if (this.lockProvider.Mobifone && this.viettelLockDate === null) {
          this.mobifoneLockDate = this.lockProvider.mobifoneEnterDate
        }
        if (this.lockProvider.Vinaphone && this.viettelLockDate === null) {
          this.vinaphoneLockDate = this.lockProvider.vinaphoneEnterDate
        }
        if (this.lockProvider.Other && this.viettelLockDate === null) {
          this.otherLockDate = this.lockProvider.otherEnterDate
        }

        if (this.phoneNumberDetail.viettel_using_status === 'LOCK' && this.viettelLockDate === null) {
          this.lockProvider.Viettel = true
          this.viettelLockDate = moment().format('yyyy-MM-DD')
        }
        if (this.phoneNumberDetail.mobifone_using_status === 'LOCK' && this.mobifoneLockDate === null) {
          this.lockProvider.Mobifone = true
          this.mobifoneLockDate = moment().format('yyyy-MM-DD')
        }
        if (this.phoneNumberDetail.vinaphone_using_status === 'LOCK' && this.vinaphoneLockDate === null) {
          this.lockProvider.Vinaphone = true
          this.vinaphoneLockDate = moment().format('yyyy-MM-DD')
        }
        if (this.phoneNumberDetail.other_using_status === 'LOCK' && this.otherLockDate === null) {
          this.lockProvider.Other = true
          this.otherLockDate = moment().format('yyyy-MM-DD')
        }
      }

      if (phoneNumber.phone_number_status === this.statusPhoneNumberId.RETEST) {
        if (this.phoneNumberDetail.viettel_unlocking_status === 'OPENED') {
          this.unlockProvider.Viettel = true
          this.viettelUnLockDate = moment().format('yyyy-MM-DD')
        }
        if (this.phoneNumberDetail.mobifone_unlocking_status === 'OPENED') {
          this.unlockProvider.Mobifone = true
          this.mobifoneUnLockDate = moment().format('yyyy-MM-DD')
        }
        if (this.phoneNumberDetail.vinaphone_unlocking_status === 'OPENED') {
          this.unlockProvider.Vinaphone = true
          this.vinaphoneUnLockDate = moment().format('yyyy-MM-DD')
        }
        if (this.phoneNumberDetail.other_unlocking_status === 'OPENED') {
          this.unlockProvider.Other = true
          this.otherUnLockDate = moment().format('yyyy-MM-DD')
        }
      }
    },
    initFilter () {
      const legalList = localStorage.getItem(LOCAL_STORAGE_KEY.LEGAL_LIST)
      if (legalList) {
        this.legalList = JSON.parse(legalList)
      }
      const mainPhoneNumberList = localStorage.getItem(LOCAL_STORAGE_KEY.MAIN_PHONE_NUMBER_LIST)
      if (mainPhoneNumberList) {
        this.mainPhoneNumberList = JSON.parse(mainPhoneNumberList)
      }
      const phoneClientList = localStorage.getItem(LOCAL_STORAGE_KEY.PHONE_NUMBER_CLIENT)
      if (phoneClientList) {
        this.phoneClientList = JSON.parse(phoneClientList)
      }
      const phoneStatusList = localStorage.getItem(LOCAL_STORAGE_KEY.PHONE_STATUS_LIST)
      if (phoneStatusList) {
        this.phoneStatusList = JSON.parse(phoneStatusList)
      }
      const providerList = localStorage.getItem(LOCAL_STORAGE_KEY.PROVIDER_LIST)
      if (providerList) {
        this.providerList = JSON.parse(providerList)
      }
    },
    back () {
      this.hideModal('phoneNumberDetailChecking')
    },
    confirmQualified (isQualified) {
      this.$bvModal.msgBoxConfirm(isQualified ? 'Xác nhận số đạt?' : 'Xác nhận số không đạt', {
        title: false,
        buttonSize: 'sm',
        centered: true,
        size: 'sm',
        footerClass: 'p-2'
      }).then(res => {
        if (res) {
          const dto = this.buildDto()
          dto.phone_number_status_id = isQualified ? this.statusPhoneNumberId.QUALIFIED : this.statusPhoneNumberId.UNQUALIFIED
          PhoneNumberAPI.check(dto).then(res => {
            Utils.successToast(this.$bvToast)
            this.buildDtoFromResponse(res.data.data)
            this.hideModal('phoneNumberDetailChecking')
          }).catch(err => {
            Utils.handleError(this.$bvToast, err)
          })
        }
      })
    },
    backToNew () {
      this.$bvModal.msgBoxConfirm('Chuyển về hàng chờ kiểm tra?', {
        title: false,
        buttonSize: 'sm',
        centered: true,
        size: 'sm',
        footerClass: 'p-2'
      }).then(res => {
        if (res) {
          const dto = this.buildDto()
          dto.phone_number_status_id = this.statusPhoneNumberId.NEW
          PhoneNumberAPI.check(dto).then(res => {
            Utils.successToast(this.$bvToast)
            this.buildDtoFromResponse(res.data.data)
            this.hideModal('phoneNumberDetailChecking')
          }).catch(err => {
            Utils.handleError(this.$bvToast, err)
          })
        }
      })
    },
    confirmLock () {
      this.$bvModal.msgBoxConfirm('Bạn có đồng ý khóa số điện thoại này?', {
        title: false,
        buttonSize: 'sm',
        centered: true,
        size: 'sm',
        footerClass: 'p-2'
      }).then(res => {
        if (res) {
          const dto = this.buildDto()
          dto.phone_number_status_id = this.statusPhoneNumberId.LOCKED
          PhoneNumberAPI.check(dto).then(res => {
            Utils.successToast(this.$bvToast)
            this.buildDtoFromResponse(res.data.data)
            this.hideModal('phoneNumberDetailChecking')
          }).catch(err => {
            Utils.handleError(this.$bvToast, err)
          })
        }
      })
    },
    confirmCancel () {
      this.$bvModal.msgBoxConfirm('Bạn có đồng ý hủy số điện thoại này?', {
        title: false,
        buttonSize: 'sm',
        centered: true,
        size: 'sm',
        footerClass: 'p-2'
      }).then(res => {
        if (res) {
          const dto = this.buildDto()
          dto.phone_number_status_id = this.statusPhoneNumberId.CONFIRM_CANCEL
          PhoneNumberAPI.check(dto).then(res => {
            Utils.successToast(this.$bvToast)
            this.buildDtoFromResponse(res.data.data)
            this.hideModal('phoneNumberDetailChecking')
          }).catch(err => {
            Utils.handleError(this.$bvToast, err)
          })
        }
      })
    },
    confirmNotUse () {
      this.$bvModal.msgBoxConfirm('Bạn có xác nhận không dùng số điện thoại này?', {
        title: false,
        buttonSize: 'sm',
        centered: true,
        size: 'sm',
        footerClass: 'p-2'
      }).then(res => {
        if (res) {
          const dto = this.buildDto()
          dto.phone_number_status_id = this.statusPhoneNumberId.CONFIRM_NOT_USE
          PhoneNumberAPI.check(dto).then(res => {
            Utils.successToast(this.$bvToast)
            this.buildDtoFromResponse(res.data.data)
            this.hideModal('phoneNumberDetailChecking')
          }).catch(err => {
            Utils.handleError(this.$bvToast, err)
          })
        }
      })
    },
    warningAlert () {
      this.$bvModal.msgBoxConfirm('Bạn có đồng ý cảnh báo sai cho số điện thoại này?', {
        title: false,
        buttonSize: 'sm',
        centered: true,
        size: 'sm',
        footerClass: 'p-2'
      }).then(res => {
        if (res) {
          const dto = this.buildDto()
          dto.phone_number_status_id = this.statusPhoneNumberId.FALSE_POSITIVE
          PhoneNumberAPI.check(dto).then(res => {
            Utils.successToast(this.$bvToast)
            this.buildDtoFromResponse(res.data.data)
            this.hideModal('phoneNumberDetailChecking')
          }).catch(err => {
            Utils.handleError(this.$bvToast, err)
          })
        }
      })
    },
    confirmUnlocked () {
      this.$bvModal.msgBoxConfirm('Xác nhận số đã được mở?', {
        title: false,
        buttonSize: 'sm',
        centered: true,
        size: 'sm',
        footerClass: 'p-2'
      }).then(res => {
        if (res) {
          const dto = this.buildDto()
          dto.phone_number_status_id = this.statusPhoneNumberId.UNLOCKED
          PhoneNumberAPI.check(dto).then(res => {
            Utils.successToast(this.$bvToast)
            this.buildDtoFromResponse(res.data.data)
            this.hideModal('phoneNumberDetailChecking')
          }).catch(err => {
            Utils.handleError(this.$bvToast, err)
          })
        }
      })
    },
    backToChecking () {
      this.$bvModal.msgBoxConfirm('Bạn có đồng ý chuyển về trạng thái nghi ngờ?', {
        title: false,
        buttonSize: 'sm',
        centered: true,
        size: 'sm',
        footerClass: 'p-2'
      }).then(res => {
        if (res) {
          const dto = this.buildDto()
          dto.phone_number_status_id = this.statusPhoneNumberId.MONITORING
          PhoneNumberAPI.check(dto).then(res => {
            Utils.successToast(this.$bvToast)
            this.buildDtoFromResponse(res.data.data)
            this.hideModal('phoneNumberDetailChecking')
          }).catch(err => {
            Utils.handleError(this.$bvToast, err)
          })
        }
      })
    },
    buildRequestProvider () {
      let status = {}
      this.usingStatusProviders.forEach(provider => { status[provider.key] = provider.status ? provider.status : 'IN_QUEUE' })
      return status
    },
    buildRequestLockingProvider () {
      let status = {}
      this.lockingStatusProviders.forEach(provider => { status[provider.key] = provider.status ? provider.status : 'AVAILABLE' })
      return status
    },
    buildDto () {
      return {
        id: this.phoneNumberDetail.id,
        viettel_lock_date: this.lockProvider.Viettel ? this.viettelLockDate : null,
        mobifone_lock_date: this.lockProvider.Mobifone ? this.mobifoneLockDate : null,
        vinaphone_lock_date: this.lockProvider.Vinaphone ? this.vinaphoneLockDate : null,
        other_lock_date: this.lockProvider.Other ? this.otherLockDate : null,
        viettel_unlock_date: this.unlockProvider.Viettel ? this.viettelUnLockDate : null,
        mobifone_unlock_date: this.unlockProvider.Mobifone ? this.mobifoneUnLockDate : null,
        vinaphone_unlock_date: this.unlockProvider.Vinaphone ? this.vinaphoneUnLockDate : null,
        other_unlock_date: this.unlockProvider.Other ? this.otherUnLockDate : null,
      }
    },
  }
}
</script>

<style scoped>
td, th {
  padding: 10px 50px;
}
</style>



// WEBPACK FOOTER //
// src/views/phone_number_management/techical_list/PhoneNumberChecking.vue